import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/whatsapp';

const { FiArrowUpRight } = FiIcons;

function Story() {
  return (
    <section className="story-section" id="story">
      <div className="story-image" role="img" aria-label="Athlete training in a dramatic sunlit gym" />
      <div className="story-copy">
        <span className="eyebrow">Built for the long run</span>
        <h2>Strength is a practice.<br /><em>Not a finish line.</em></h2>
        <p>Good training meets you where you are, then gives you room to go further. Our coaches, programming and community are here for every step in between.</p>
        <ul className="story-list">
          <li><strong>01</strong><span>Thoughtful coaching that adapts to your life, not the other way around.</span></li>
          <li><strong>02</strong><span>Programming built on real progressions, not random workouts.</span></li>
          <li><strong>03</strong><span>A community that shows up for each other, on the good days and the hard ones.</span></li>
        </ul>
        <a className="text-link" href={waLink('I would love to learn more about the Forge approach.')} target="_blank" rel="noreferrer">
          Meet your people <SafeIcon icon={FiArrowUpRight} />
        </a>
      </div>
    </section>
  );
}
export default Story;
